import request from '@/utils/request'

export function epms6010(param) {
    let data = param
    return request({
        url: `/supplier/epms6010/epms6010`,
        method: 'POST',
        meta: { apiVersion: '1.0.0' },
        headers: { 'Content-Type': 'application/json;charset=utf8' },
        data
    })
}